import { render, staticRenderFns } from "./scaleSet.vue?vue&type=template&id=55baf313&scoped=true&"
import script from "./scaleSet.vue?vue&type=script&lang=js&"
export * from "./scaleSet.vue?vue&type=script&lang=js&"
import style0 from "./scaleSet.vue?vue&type=style&index=0&id=55baf313&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55baf313",
  null
  
)

export default component.exports